<div class="wave-indicator">
  <div *ngFor="let dot of dots; let i = index" 
       class="wave-dot" 
       [style.animation-delay]="(i * 0.1) + 's'">
  </div>
</div>

